import React from 'react';
import { FeedbackQuestion } from '../../types/feedback';
import {
  TextQuestion,
  TextareaQuestion,
  RadioQuestion,
  CheckboxQuestion,
  RatingQuestion,
  SelectQuestion
} from './QuestionTypes';

interface DynamicQuestionProps {
  question: FeedbackQuestion;
  value: any;
  onChange: (value: any) => void;
  error?: string;
}

const DynamicQuestion: React.FC<DynamicQuestionProps> = ({
  question,
  value,
  onChange,
  error
}) => {
  // Ensure we have a default value based on question type
  const getDefaultValue = () => {
    switch (question.type) {
      case 'checkbox':
        return Array.isArray(value) ? value : [];
      case 'rating':
        return typeof value === 'number' ? value : 0;
      case 'number':
        return typeof value === 'number' ? value : '';
      default:
        return typeof value === 'string' ? value : '';
    }
  };

  const currentValue = getDefaultValue();

  switch (question.type) {
    case 'text':
    case 'email':
      return (
        <TextQuestion
          question={question}
          value={String(currentValue || '')}
          onChange={onChange}
          error={error}
        />
      );

    case 'textarea':
      return (
        <TextareaQuestion
          question={question}
          value={String(currentValue || '')}
          onChange={onChange}
          error={error}
        />
      );

    case 'radio':
      return (
        <RadioQuestion
          question={question}
          value={String(currentValue || '')}
          onChange={onChange}
          error={error}
        />
      );

    case 'checkbox':
      return (
        <CheckboxQuestion
          question={question}
          value={Array.isArray(currentValue) ? currentValue : []}
          onChange={onChange}
          error={error}
        />
      );

    case 'rating':
    case 'number':
      return (
        <RatingQuestion
          question={question}
          value={typeof currentValue === 'number' ? currentValue : 0}
          onChange={onChange}
          error={error}
        />
      );

    case 'select':
      return (
        <SelectQuestion
          question={question}
          value={String(currentValue || '')}
          onChange={onChange}
          error={error}
        />
      );

    default:
      return (
        <div className="question-container">
          <p className="error-message">
            Unsupported question type: {question.type}
          </p>
        </div>
      );
  }
};

export default DynamicQuestion;
